import moment from 'moment/moment'
import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { polyglot } from '../../../../index'
import { cleanArray } from '../../../../resources/utilities'
import Consultation from '../Consultation/Consultation'
import SectionTitle from '../../../common/SectionTitle/SectionTitle'
import { Button } from '../../../common/Button/Button'
import ConsultationInsertion from '../ConsultationInsertion/ConsultationInsertion'
import { ReactModal } from '../../../common/ReactModal/ReactModal'
import HelpBubble from '../../../common/HelpBubble/HelpBubble'

import './style.css'
import Graphics from './Graphics/Graphics'

export default class Range extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      routineConsultations: undefined,
      patientConsultations: undefined,
      consultationForModal: undefined,
      modalIsOpen: false
    }
    this.toggleModal = this.toggleModal.bind(this)
    this.renderConsultationInsertion = this.renderConsultationInsertion.bind(this)
  }

  getRangeById (id) {
    const consultationRange = this.props.configuration.ageRange
    let rangeToReturn
    consultationRange.forEach(element => {
      if (element.id.toString() === id) {
        rangeToReturn = element
      }
    })
    return rangeToReturn
  }

  toggleModal () {
    const status = !this.state.modalIsOpen
    if (!status) {
      this.setState({
        consultationForModal: undefined,
        modalIsOpen: status
      })
    } else {
      this.setState({
        modalIsOpen: status
      })
    }
  }

  getConsultationStatus (consultation, savedData) {
    const today = moment()
    const consultationStart = moment(this.props.patient.birthDate).add(moment.duration(consultation.ageInterval.start))
    const consultationEnd = moment(this.props.patient.birthDate).add(moment.duration(consultation.ageInterval.end))
    if (today.isAfter(consultationEnd)) {
      if (savedData) {
        return 'onTime'
      } else {
        return 'late'
      }
    } else {
      if (today.isBefore(consultationStart)) {
        return 'future'
      }
    }
    if (today.isBetween(consultationStart, consultationEnd, null, '[]')) {
      if (savedData) {
        return 'onTime'
      } else {
        return 'now'
      }
    }
  }

  getAdditionalConsultations (key, consultation) {
    const consultationDate = moment(new Date(consultation.date))
    const range = this.getRangeById(this.props.rangeId)
    const patientBirthDate = this.props.patient['birthDate']
    const rangeStart = moment(patientBirthDate).add(moment.duration(range.start))
    const rangeEnd = moment(patientBirthDate).add(moment.duration(range.finish))
    if (consultationDate.isBetween(rangeStart, rangeEnd, null, '[]')) {
      const healthParameters = ['001', '030', '003', '004', '022']
      const _healthParameters = []
      healthParameters.forEach(parameter => {
        _healthParameters.push({name: this.getParameterForId(parameter).name, label: this.getParameterForId(parameter).label})
      })
      if (!consultation.hasOwnProperty('routineConsultationId')) {
        return {
          date: consultation.date,
          consultationStatus: 'additional',
          key: key,
          savedData: consultation,
          title: moment(new Date(consultation.date)).format('LL'),
          healthParameters: _healthParameters,
          examinedParameters: consultation.examinedParameters,
          addressedTopics: consultation.conversationTopics
        }
      }
    }
  }

  getConsultationData (key, consultation) {
    const healthParameters = []
    let savedData
    const consultations = this.props.patient.data.consultations
    if (consultations) {
      Object.keys(consultations).forEach(key => {
        const obj = consultations[key]
        if (obj.routineConsultationId === consultation.id) {
          savedData = consultations[key]
        }
      })
    }
    if (consultation.healthParameters) {
      consultation.healthParameters.forEach(parameter => {
        healthParameters.push({name: this.getParameterForId(parameter).name, label: this.getParameterForId(parameter).label})
      })
    }
    const examinedParameters = []
    if (consultation.examinedParameters) {
      consultation.examinedParameters.forEach(parameter => {
        examinedParameters.push({name: this.getParameterForId(parameter).name, label: this.getParameterForId(parameter).label})
      })
    }
    const conversationTopics = []
    if (consultation.conversationTopics) {
      consultation.conversationTopics.forEach(parameter => {
        conversationTopics.push({name: this.getTopicsForId(parameter).name, label: this.getTopicsForId(parameter).label})
      })
    }
    const title = polyglot.t(consultation.description) || moment(new Date(savedData.date)).format('LL')
    const consultationStatus = this.getConsultationStatus(consultation, savedData)
    let rightField
    let openable
    if (savedData) {
      rightField = title === savedData.date ? null : <div>{moment(new Date(savedData.date)).format('LL')}</div>
    } else {
      if (consultationStatus === 'now') {
        rightField = <Button
          text={polyglot.t('staticFields.commonFields.fill')}
          buttonType={'btn btn-sm btn-default'}
          type={'btn'}
          onClick={() => {
            this.setState({
              consultationForModal: consultation
            })
            this.toggleModal()
          }} />
      } else if (consultationStatus !== 'future') {
        openable = false
        rightField = <div>{polyglot.t('staticFields.range.consultationWithoutRegister')}</div>
      }
    }
    const date = (savedData && savedData.date) || moment(this.props.patient.birthDate).add(moment.duration(consultation.ageInterval.start)).toString()
    return {
      date: date,
      consultation: consultation,
      openable: openable,
      consultationStatus: consultationStatus,
      rightField: rightField,
      key: key,
      savedData: savedData,
      title: title,
      healthParameters: healthParameters,
      examinedParameters: examinedParameters,
      conversationTopics: conversationTopics
    }
  }

  renderConsultation (data) {
    return <Consultation
      openable={data.openable}
      consultationStatus={data.consultationStatus}
      rightField={data.rightField}
      key={data.key}
      savedData={data.savedData}
      title={data.title}
      healthParameters={data.healthParameters}
      examinedParameters={data.examinedParameters}
      conversationTopics={data.conversationTopics} />
  }

  getParameterForId (id) {
    return this.props.configuration['analizedParameters'][id]
  }

  getTopicsForId (id) {
    return this.props.configuration['conversationTopics'][id]
  }

  renderConsultationInsertion () {
    if (this.state.consultationForModal) {
      return <ConsultationInsertion
        toggleModal={this.toggleModal}
        configuration={this.props.configuration}
        consultation={this.props.configuration.consultations[this.state.consultationForModal.id]}
        consultationId={this.state.consultationForModal.id}
        patientKey={this.props.patientKey}
        patientData={this.props.patient.data} />
    } else {
      return <div>
        <ConsultationInsertion
          toggleModal={this.toggleModal}
          configuration={this.props.configuration}
          consultation={{healthParameters: ['001', '030', '003', '004', '022']}}
          patientKey={this.props.patientKey}
          patientData={this.props.patient.data} />
      </div>
    }
  }

  getRoutineConsultationsForRange (interval) {
    const consultations = []
    const routineConsultation = this.props.configuration.consultations
    routineConsultation.forEach(consultation => {
      const patientBirthDate = this.props.patient.birthDate
      const consultationStart = moment(patientBirthDate).add(moment.duration(consultation.ageInterval.start))
      const consultationEnd = moment(patientBirthDate).add(moment.duration(consultation.ageInterval.end))
      const rangeStart = moment(patientBirthDate).add(moment.duration(interval.start))
      const rangeEnd = moment(patientBirthDate).add(moment.duration(interval.end))
      if (consultationStart.isBetween(rangeStart, rangeEnd, null, '[]') || consultationEnd.isBetween(rangeStart, rangeEnd, null, '[]')) {
        consultations.push(consultation)
      }
    })
    return consultations
  }

  getPatientConsultations (consultations) {
    const _consultations = []
    if (consultations) {
      Object.keys(consultations).forEach(key => {
        let consultation = consultations[key]
        _consultations.push(consultation)
      })
      return _consultations
    }
  }

  componentWillReceiveProps (props) {
    const range = this.getRangeById(props.rangeId)
    const routineConsultations = this.getRoutineConsultationsForRange({start: range.start, end: range.finish})
    const patientConsultations = this.getPatientConsultations(props.patient.data.consultations)
    this.setState({
      patientConsultations: patientConsultations,
      routineConsultations: routineConsultations
    })
  }

  componentWillMount () {
    const range = this.getRangeById(this.props.rangeId)
    const routineConsultations = this.getRoutineConsultationsForRange({start: range.start, end: range.finish})
    const patientConsultations = this.getPatientConsultations(this.props.patient.data.consultations)
    this.setState({
      patientConsultations: patientConsultations,
      routineConsultations: routineConsultations
    })
  }

  isRangeCurrent () {
    const today = moment()
    const currentRange = this.getRangeById(this.props.rangeId)
    const rangeStart = moment(new Date(this.props.patient.birthDate)).add(moment.duration(currentRange.start))
    const rangeEnd = moment(new Date(this.props.patient.birthDate)).add(moment.duration(currentRange.finish))
    return today.isBetween(rangeStart, rangeEnd, null, '[]')
  }

  renderConsultations () {
    let consultations = []
    if (this.state.routineConsultations) {
      Object.keys(this.state.routineConsultations).forEach(key => {
        const consultation = this.state.routineConsultations[key]
        consultations.push(this.getConsultationData(key, consultation))
      })
    }
    if (this.state.patientConsultations) {
      Object.keys(this.state.patientConsultations).forEach(key => {
        const consultation = this.state.patientConsultations[key]
        consultations.push(this.getAdditionalConsultations(key, consultation))
      })
    }
    consultations = cleanArray(consultations)
    consultations.sort(function (a, b) {
      if (moment(new Date(a.date)).isBefore(moment(new Date(b.date)))) {
        return -1
      } else if (moment(new Date(a.date)).isAfter(moment(new Date(b.date)))) {
        return 1
      } else {
        return 0
      }
    })
    return Object.keys(consultations).map(key => {
      const consultation = consultations[key]
      return this.renderConsultation(consultation)
    })
  }

  getHelpContent () {
    return <div className='row'>
      <div className='col-xs-6 col-sm-6 help-box'>
        <div className='help red' />
        <div className='red no-background-color'>{`${polyglot.t('staticFields.range.help.notDone')}`}</div>
      </div>
      <div className='col-xs-6 col-sm-6 help-box'>
        <div className='help green' />
        <div className='green no-background-color'>{`${polyglot.t('staticFields.range.help.done')}`}</div>
      </div>
      <div className='col-xs-6 col-sm-6 help-box'>
        <div className='help grey' />
        <div className='grey no-background-color'>{`${polyglot.t('staticFields.range.help.future')}`}</div>
      </div>
      <div className='col-xs-6 col-sm-6 help-box'>
        <div className='help blue' />
        <div className='blue no-background-color'>{`${polyglot.t('staticFields.range.help.extra')}`}</div>
      </div>
    </div>
  }
  render () {
    window.myLogger.info(JSON.stringify({message: 'Range Component Rendered', rangeId: this.props.rangeId}))
    return <Fragment>
      <div className='col-xs-12'>
        <SectionTitle
          title={<div style={{display: 'inline-block'}}>
            <div className='pull-left' style={{marginRight: '15px'}}>
              <HelpBubble content={this.getHelpContent()} />
            </div>
            {polyglot.t('staticFields.range.consultations')}
          </div>}
          size={'h4'}
          rightField={this.isRangeCurrent()
            ? <Button text={polyglot.t('staticFields.commonFields.add')} onClick={this.toggleModal} buttonType={'btn btn-sm btn-primary'} type={'button'} />
            : null} />
      </div>
      <div className='col-xs-12'>
        {this.renderConsultations()}
      </div>
      <div className='col-xs-12'>
        <SectionTitle title={polyglot.t('staticFields.range.graphics')} size={'h4'} />
        <Graphics patient={this.props.patient} rangeId={this.props.rangeId} />
      </div>
      <ReactModal fullWidth name={polyglot.t('staticFields.commonFields.insertion')} toggleModal={this.toggleModal} modalIsOpen={this.state.modalIsOpen}>
        {this.renderConsultationInsertion()}
      </ReactModal>
    </Fragment>
  }
}

Range.propTypes = {
  rangeId: PropTypes.string.isRequired,
  configuration: PropTypes.object.isRequired,
  patient: PropTypes.object.isRequired,
  patientKey: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/Consultations/Range/Range.js